export default "__VITE_ASSET__BCrn0_$V__"